(() => {
  if (window.TDDStorefrontInitialized) return;
  window.TDDStorefrontInitialized = true;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let observer = null;

  if ('IntersectionObserver' in window && !reduceMotion) {
    observer = new IntersectionObserver((entries, currentObserver) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        currentObserver.unobserve(entry.target);
        entry.target.removeAttribute('data-tdd-observed');
      });
    }, { threshold: 0.12 });
  }

  const revealItems = (root = document) => {
    const items = [];

    if (root instanceof Element && root.matches('[data-tdd-reveal]')) {
      items.push(root);
    }

    if (root.querySelectorAll) {
      items.push(...root.querySelectorAll('[data-tdd-reveal]'));
    }

    items.forEach((item) => {
      if (item.classList.contains('is-visible')) return;

      if (!observer) {
        item.classList.add('is-visible');
        return;
      }

      if (item.hasAttribute('data-tdd-observed')) return;
      item.setAttribute('data-tdd-observed', '');
      observer.observe(item);
    });
  };

  revealItems(document);

  // Shopify replaces section HTML while editing. Re-register reveal elements
  // so newly uploaded images and edited content do not remain transparent.
  document.addEventListener('shopify:section:load', (event) => {
    revealItems(event.target);
  });

  document.addEventListener('shopify:block:select', (event) => {
    revealItems(event.target.closest('.shopify-section') || event.target);
  });

  document.addEventListener('shopify:section:select', (event) => {
    revealItems(event.target);
  });
})();
